import React from 'react';
import { Box, Typography, Avatar, IconButton } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import CloseIcon from '@mui/icons-material/Close';

const cardSx = {
  width: 340,
  backgroundColor: '#fff',
  borderRadius: 2,
  p: 1.5,
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative'
};

/**
 * Shared chrome for project / email snackbars from notistack (Custom*NotificationContent).
 */
const NotificationSnackbarLayout = React.forwardRef((props, ref) => {
  const {
    closeSnackbar,
    isUnread,
    avatarSrc,
    avatarChildren,
    primaryLine,
    secondaryLine,
    bodyText,
    captionDate
  } = props;

  const primaryColor = isUnread ? '#FF8C00' : '#12014B';
  const secondaryColor = isUnread ? '#8D00F2' : '#4B4B4B';

  return (
    <Box ref={ref} sx={cardSx}>
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <Avatar src={avatarSrc} sx={{ width: 40, height: 40, mr: 1 }}>
          {avatarChildren}
        </Avatar>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="body2" sx={{ color: primaryColor, fontWeight: 600 }}>
            {primaryLine}{' '}
            <Typography
              component="span"
              variant="body2"
              sx={{ color: secondaryColor, fontWeight: 600 }}
            >
              {secondaryLine}
            </Typography>
          </Typography>
        </Box>
        {isUnread && <CircleIcon sx={{ fontSize: 10, color: '#FF8C00' }} />}
      </Box>

      <Typography variant="body2" sx={{ color: '#4A4A4A', mt: 1 }}>
        {bodyText}
      </Typography>
      <Typography variant="caption" sx={{ color: '#8F8F8F' }}>
        {captionDate}
      </Typography>

      <IconButton
        size="small"
        sx={{ position: 'absolute', top: 4, right: 4 }}
        onClick={closeSnackbar}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
});

NotificationSnackbarLayout.displayName = 'NotificationSnackbarLayout';
export default NotificationSnackbarLayout;
